"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=e=>typeof e>"u"?!1:typeof e=="boolean"?e:typeof e!="string"?!1:e==="true";exports.toBoolean=t;
